export interface TokenStorage {
  getToken(): string | null
  setToken(token: string): void
  clearToken(): void
}

export interface CreateTokenStorageOptions {
  storageKey?: string
  storage?: Storage
}

export const createTokenStorage = (options: CreateTokenStorageOptions = {}): TokenStorage => {
  const storageKey = options.storageKey ?? 'authToken'
  const storage = options.storage ?? (typeof window !== 'undefined' ? window.localStorage : undefined)

  return {
    getToken(): string | null {
      if (!storage) {
        return null
      }

      try {
        return storage.getItem(storageKey)
      } catch (error) {
        console.warn('[api-client] localStorage getToken failed', error)
        return null
      }
    },
    setToken(token: string) {
      if (!storage) {
        return
      }

      try {
        storage.setItem(storageKey, token)
      } catch (error) {
        console.warn('[api-client] localStorage setToken failed', error)
      }
    },
    clearToken() {
      if (!storage) {
        return
      }

      try {
        storage.removeItem(storageKey)
      } catch (error) {
        console.warn('[api-client] localStorage clearToken failed', error)
      }
    },
  }
}


